module.exports = __webpack_public_path__ + "b0f3d1ae910e63081249157ff106ae04.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/images_en/home-bg-1.png
// module id = 1120
// module chunks = 0